export const RECEIVE_DATA = "RECEIVE_DATA";
export const UPDATE_SEARCH_STORE_QUERY = "UPDATE_SEARCH_STORE_QUERY";
export const UPDATE_SEARCH_PROMOCODE_QUERY = "UPDATE_SEARCH_PROMOCODE_QUERY";
export const UPDATE_SPLASH_SCREEN_VISIBILITY = "UPDATE_SPLASH_SCREEN_VISIBILITY";
export const UPDATE_APP_SETTINGS = "UPDATE_APP_SETTINGS";
export const UPDATE_DATA_CATEGORIES = "UPDATE_DATA_CATEGORIES";
export const UPDATE_APP_GUIDE_COMPLETE = "UPDATE_APP_GUIDE_COMPLETE";
